import Swal from 'sweetalert2'

export default {
  install: (app) => {
    app.config.globalProperties.$swalLoading = () => {
      Swal.fire({
        allowOutsideClick: false,
      });
      Swal.showLoading();
    };

    app.config.globalProperties.$swalClose = () => {
      Swal.close();
    };

    app.config.globalProperties.$swalSuccess = (message) => {
      Swal.fire({
        icon: 'success',
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    };
    
  }
}